/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown> }} Invite_X15_Join_AsInputs */

const en_invite_x15_join_as = /** @type {(inputs: Invite_X15_Join_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Join as ${i?.current}`)
};

/** @type {(inputs: Invite_X15_Join_AsInputs) => LocalizedString} */
const ar_invite_x15_join_as = en_invite_x15_join_as;

/** @type {(inputs: Invite_X15_Join_AsInputs) => LocalizedString} */
const he_invite_x15_join_as = en_invite_x15_join_as;

/** @type {(inputs: Invite_X15_Join_AsInputs) => LocalizedString} */
const ur_invite_x15_join_as = en_invite_x15_join_as;

/** @type {(inputs: Invite_X15_Join_AsInputs) => LocalizedString} */
const es_invite_x15_join_as = en_invite_x15_join_as;

/** @type {(inputs: Invite_X15_Join_AsInputs) => LocalizedString} */
const fr_invite_x15_join_as = en_invite_x15_join_as;

/** @type {(inputs: Invite_X15_Join_AsInputs) => LocalizedString} */
const de_invite_x15_join_as = en_invite_x15_join_as;

/** @type {(inputs: Invite_X15_Join_AsInputs) => LocalizedString} */
const pt_invite_x15_join_as = en_invite_x15_join_as;

/** @type {(inputs: Invite_X15_Join_AsInputs) => LocalizedString} */
const hi_invite_x15_join_as = en_invite_x15_join_as;

/** @type {(inputs: Invite_X15_Join_AsInputs) => LocalizedString} */
const bn_invite_x15_join_as = en_invite_x15_join_as;

/**
* | output |
* | --- |
* | "Join as {current}" |
*
* @param {Invite_X15_Join_AsInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const invite_x15_join_as = /** @type {((inputs: Invite_X15_Join_AsInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_X15_Join_AsInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_invite_x15_join_as(inputs)
	if (locale === "he") return he_invite_x15_join_as(inputs)
	if (locale === "ur") return ur_invite_x15_join_as(inputs)
	if (locale === "es") return es_invite_x15_join_as(inputs)
	if (locale === "fr") return fr_invite_x15_join_as(inputs)
	if (locale === "de") return de_invite_x15_join_as(inputs)
	if (locale === "pt") return pt_invite_x15_join_as(inputs)
	if (locale === "hi") return hi_invite_x15_join_as(inputs)
	if (locale === "bn") return bn_invite_x15_join_as(inputs)
	return en_invite_x15_join_as(inputs)
});